<template>
  <div class="weui-content">
    <div class="weui-c-inner">
      <div class="weui-c-content">
        <h2 class="weui-c-title">缅怀捐献者 感恩生命曙光</h2>
        <div class="weui-c-meta">
          <span class="weui-c-nickname"><a>生命的曙光</a></span>
        </div>
        <div class="weui-c-article">
          <img src="../../image/smhx_ysmh/section/n1.jpg" style="width: 100;">
          <img src="../../image/smhx_ysmh/section/n2.png" style="width: 100;">
          <img src="../../image/smhx_ysmh/section/n2.gif" style="width: 100;">
          <section data-support="96编辑器" data-style-id="36345" style="visibility: visible;">
            <section style="text-align: center; margin-top: 10px; margin-bottom: 10px; visibility: visible;">
              <section style="width: 34px; margin-left: auto; margin-bottom: -30px; visibility: visible;"><img
                  data-ratio="0.7906976744186046"
                  data-src="https://mmbiz.qpic.cn/mmbiz_png/Ljib4So7yuWiau1y85xSzNAFQpTcycCNVxiaxgow7ZpOH286kGpu68XrIMvribNBia7AlUMjnGtxADKV6E2SwqWy8iaw/640?wx_fmt=png"
                  data-type="png" data-w="43" data-width="100%"
                  style="display: block; width: 100% !important; height: auto !important; visibility: visible !important;"
                  data-index="3" class="" src="../../image/smhx_ysmh/section/n3.png" _width="100%" crossorigin="anonymous"
                  alt="图片" data-fail="0"></section>
              <section
                style="display: flex; justify-content: space-between; align-items: flex-start; overflow: hidden; transform: rotateZ(0deg); visibility: visible;">
                <section
                  style="margin-top: -10px; margin-left: -10px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: rgb(69, 159, 86); width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                  <br style="visibility: visible;">
                </section>
                <section style="width: 97%; height: 1px; background-color: rgb(69, 159, 86); visibility: visible;"
                  data-width="97%"><br style="visibility: visible;"></section>
                <section
                  style="margin-top: -10px; margin-right: -10px; width: 20px; height: 20px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: rgb(69, 159, 86); box-sizing: border-box; visibility: visible;">
                  <br style="visibility: visible;">
                </section>
              </section>
              <section
                style="margin-top: -5px; margin-right: 4px; margin-left: 4px; background-color: rgb(243, 255, 245); visibility: visible;">
                <section
                  style="display: flex; justify-content: space-between; align-items: flex-start; overflow: hidden; visibility: visible;">
                  <section style="margin-top: -10px; margin-left: -10px; visibility: visible;">
                    <section
                      style="background-color: rgb(253, 253, 253); padding: 3px; border-radius: 50%; width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                      <br style="visibility: visible;">
                    </section>
                  </section>
                  <section style="margin-top: -10px; margin-right: -10px; visibility: visible;">
                    <section
                      style="background-color: rgb(253, 253, 253); padding: 3px; border-radius: 50%; width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                      <br style="visibility: visible;">
                    </section>
                  </section>
                </section>
              </section>
              <section
                style="margin-top: -7px;border-left: 1px solid rgb(69, 159, 86);border-right: 1px solid rgb(69, 159, 86);padding: 3px;box-sizing: border-box;visibility: visible;">
                <section style="background-color: rgb(243, 255, 245); visibility: visible;">
                  <section style="padding: 13px; box-sizing: border-box; visibility: visible;">
                    <section
                      style="color: rgb(50, 50, 50); letter-spacing: 2px; font-size: 14px; line-height: 1.75em; text-align: justify; transform: rotateZ(0deg); visibility: visible;">
                      <p style="visibility: visible;"><span
                          style="font-size: 15px; visibility: visible;">清明期间，为缅怀纪念遗体和人体器官捐献者，弘扬社会正能量，倡导尊重生命、崇尚科学的社会新风尚，营造“自愿无偿、高尚利他”的社会氛围，进一步推动我区人体器官捐献事业高质量发展，广西壮族自治区红十字会、广西壮族自治区卫生健康委员会将在全区开展“生命·曙光”主题人体器官捐献缅怀纪念月活动。</span>
                      </p>
                    </section>
                  </section>
                </section>
              </section>
              <section style="margin-top: -10px; margin-right: 4px; margin-left: 4px; visibility: visible;">
                <section
                  style="display: flex; justify-content: space-between; align-items: flex-start; overflow: hidden; visibility: visible;">
                  <section style="margin-bottom: -10px; margin-left: -10px; visibility: visible;">
                    <section
                      style="background-color: rgb(253, 253, 253); padding: 3px; border-radius: 50%; width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                      <br style="visibility: visible;">
                    </section>
                  </section>
                  <section style="margin-bottom: -10px; margin-right: -10px; visibility: visible;">
                    <section
                      style="background-color: rgb(253, 253, 253); padding: 3px; border-radius: 50%; width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                      <br style="visibility: visible;">
                    </section>
                  </section>
                </section>
              </section>
              <section style="margin-top: -8px; visibility: visible;">
                <section
                  style="display: flex; justify-content: space-between; align-items: flex-end; overflow: hidden; transform: rotateZ(0deg); visibility: visible;">
                  <section
                    style="margin-bottom: -10px; margin-left: -10px; width: 20px; height: 20px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: rgb(69, 159, 86); background-color: rgb(254, 254, 254); box-sizing: border-box; visibility: visible;">
                    <br style="visibility: visible;">
                  </section>
                  <section style="width: 97%; height: 1px; background-color: rgb(69, 159, 86); visibility: visible;"
                    data-width="97%"><br style="visibility: visible;"></section>
                  <section
                    style="margin-bottom: -10px; margin-right: -10px; width: 20px; height: 20px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: rgb(69, 159, 86); background-color: rgb(254, 254, 254); box-sizing: border-box; visibility: visible;">
                    <br style="visibility: visible;">
                  </section>
                </section>
              </section>
            </section>
          </section>
          <!-- <img src="../../image/smhx_ysmh/section/n5.png" style="width: 100;"> -->
          <section :style="{ backgroundImage: `url(` + bg3 + `)` }"
            style="margin-top: 20px;background-attachment: initial;background-origin: initial;background-clip: initial;background-repeat: no-repeat;background-size: 100%;background-position: center bottom;">
            <section data-brushtype="text"
              style="padding: 10px 1.5em;font-size: 18px;font-weight: bold;text-align: center;letter-spacing: 1.5px;color: rgb(102, 166, 150);box-sizing: border-box;">
              <span style="font-size: 20px;">现场缅怀
              </span>
            </section>
          </section>
          <section data-support="96编辑器" data-style-id="36345" style="visibility: visible;">
            <section style="text-align: center; margin-top: 10px; margin-bottom: 10px; visibility: visible;">
              <section style="width: 34px; margin-left: auto; margin-bottom: -30px; visibility: visible;"><img
                  data-ratio="0.7906976744186046"
                  data-src="https://mmbiz.qpic.cn/mmbiz_png/Ljib4So7yuWiau1y85xSzNAFQpTcycCNVxiaxgow7ZpOH286kGpu68XrIMvribNBia7AlUMjnGtxADKV6E2SwqWy8iaw/640?wx_fmt=png"
                  data-type="png" data-w="43" data-width="100%"
                  style="display: block; width: 100% !important; height: auto !important; visibility: visible !important;"
                  data-index="3" class="" src="../../image/smhx_ysmh/section/n3.png" _width="100%" crossorigin="anonymous"
                  alt="图片" data-fail="0"></section>
              <section
                style="display: flex; justify-content: space-between; align-items: flex-start; overflow: hidden; transform: rotateZ(0deg); visibility: visible;">
                <section
                  style="margin-top: -10px; margin-left: -10px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: rgb(69, 159, 86); width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                  <br style="visibility: visible;">
                </section>
                <section style="width: 97%; height: 1px; background-color: rgb(69, 159, 86); visibility: visible;"
                  data-width="97%"><br style="visibility: visible;"></section>
                <section
                  style="margin-top: -10px; margin-right: -10px; width: 20px; height: 20px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: rgb(69, 159, 86); box-sizing: border-box; visibility: visible;">
                  <br style="visibility: visible;">
                </section>
              </section>
              <section
                style="margin-top: -5px; margin-right: 4px; margin-left: 4px; background-color: rgb(243, 255, 245); visibility: visible;">
                <section
                  style="display: flex; justify-content: space-between; align-items: flex-start; overflow: hidden; visibility: visible;">
                  <section style="margin-top: -10px; margin-left: -10px; visibility: visible;">
                    <section
                      style="background-color: rgb(253, 253, 253); padding: 3px; border-radius: 50%; width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                      <br style="visibility: visible;">
                    </section>
                  </section>
                  <section style="margin-top: -10px; margin-right: -10px; visibility: visible;">
                    <section
                      style="background-color: rgb(253, 253, 253); padding: 3px; border-radius: 50%; width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                      <br style="visibility: visible;">
                    </section>
                  </section>
                </section>
              </section>
              <section
                style="margin-top: -7px;border-left: 1px solid rgb(69, 159, 86);border-right: 1px solid rgb(69, 159, 86);padding: 3px;box-sizing: border-box;visibility: visible;">
                <section style="background-color: rgb(243, 255, 245); visibility: visible;">
                  <section style="padding: 13px; box-sizing: border-box; visibility: visible;">
                    <section
                      style="color: rgb(50, 50, 50); letter-spacing: 2px; font-size: 14px; line-height: 1.75em; text-align: justify; transform: rotateZ(0deg); visibility: visible;">
                      <p style="visibility: visible;"><span
                          style="font-size: 15px; visibility: visible;">捐献者亲友可前往南宁、桂林、柳州、钦州、贵港、百色和来宾的遗体器官捐献者纪念园进行缅怀纪念。</span>
                      </p>
                    </section>
                  </section>
                </section>
              </section>
              <section style="margin-top: -10px; margin-right: 4px; margin-left: 4px; visibility: visible;">
                <section
                  style="display: flex; justify-content: space-between; align-items: flex-start; overflow: hidden; visibility: visible;">
                  <section style="margin-bottom: -10px; margin-left: -10px; visibility: visible;">
                    <section
                      style="background-color: rgb(253, 253, 253); padding: 3px; border-radius: 50%; width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                      <br style="visibility: visible;">
                    </section>
                  </section>
                  <section style="margin-bottom: -10px; margin-right: -10px; visibility: visible;">
                    <section
                      style="background-color: rgb(253, 253, 253); padding: 3px; border-radius: 50%; width: 20px; height: 20px; box-sizing: border-box; visibility: visible;">
                      <br style="visibility: visible;">
                    </section>
                  </section>
                </section>
              </section>
              <section style="margin-top: -8px; visibility: visible;">
                <section
                  style="display: flex; justify-content: space-between; align-items: flex-end; overflow: hidden; transform: rotateZ(0deg); visibility: visible;">
                  <section
                    style="margin-bottom: -10px; margin-left: -10px; width: 20px; height: 20px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: rgb(69, 159, 86); background-color: rgb(254, 254, 254); box-sizing: border-box; visibility: visible;">
                    <br style="visibility: visible;">
                  </section>
                  <section style="width: 97%; height: 1px; background-color: rgb(69, 159, 86); visibility: visible;"
                    data-width="97%"><br style="visibility: visible;"></section>
                  <section
                    style="margin-bottom: -10px; margin-right: -10px; width: 20px; height: 20px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: rgb(69, 159, 86); background-color: rgb(254, 254, 254); box-sizing: border-box; visibility: visible;">
                    <br style="visibility: visible;">
                  </section>
                </section>
              </section>
            </section>
          </section>
        </div>
      </div>
      <div>

      </div>
      <section data-support="96编辑器" data-style-id="35373">
        <section data-support="96编辑器" data-style-id="35373">
          <section data-support="96编辑器" data-style-id="35373">
            <section style="margin-top: 10px;margin-bottom: 10px;">
              <section
                style="border-width: 4px;border-style: solid;border-color: rgb(233, 248, 238);padding: 12px;box-sizing: border-box;">
                <section>
                  <section style="margin-top: 10px;color: rgb(102, 187, 104);font-size: 18px;letter-spacing: 2px;">
                    <p>1<span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;">.广西遗体器官捐献者纪念园（南宁园）</span>
                    </p>
                  </section>
                  <section
                    style="margin-top: 8px;margin-right: 3px;margin-left: 3px;color: rgb(49, 49, 49);letter-spacing: 2px;font-size: 14px;line-height: 1.75em;transform: rotateZ(0deg);">
                    <p>地址:南宁市良庆区五象大道385号南宁市青龙岗长安墓园内白银岭上。</p>
                    <p>墓园联系电话：0<span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;">771-4</span>500070
                    </p>
                    <p>捐献咨询电话：0771-5663914</p>
                    <p><br></p>
                    <p><img class="rich_pages wxw-img" data-backh="235" data-backw="425" data-ratio="0.5529411764705883"
                        data-src="https://mmbiz.qpic.cn/mmbiz_png/erR1CfD1PHOLE76TvZWr4u4lurdA3BndAbSlYAwvZEUV8BczzWlZ3NMsBoJEYUzR87hibO4vcCQveNE8vxrDxBA/640?wx_fmt=png"
                        data-type="png" data-w="425"
                        style="width: 100% !important; height: auto !important; visibility: visible !important;"
                        data-index="11"
                        src="../../image/smhx_ysmh/section/nanning.png"
                        _width="100%" crossorigin="anonymous" alt="图片" data-fail="0"></p>
                    <p><br></p>
                  </section>
                </section>
                <section>
                  <section style="margin-top: 10px;color: rgb(102, 187, 104);font-size: 18px;letter-spacing: 2px;">
                    <p><span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;">2.
                        广西遗体器官捐献者纪念园（桂林园）</span></p>
                  </section>
                  <section
                    style="margin-top: 8px;margin-right: 3px;margin-left: 3px;color: rgb(49, 49, 49);letter-spacing: 2px;font-size: 14px;line-height: 1.75em;transform: rotateZ(0deg);">
                    <p>地址:桂林市临桂区临桂镇凤凰村委高岭底321国道南凤凰山陵园内</p>
                    <p>墓园联系电话：0773-5595555</p>
                    <p>捐献咨询电话：0773-2896981</p>
                    <p><br></p>
                    <p><img class="rich_pages wxw-img" data-backh="360" data-backw="540" data-ratio="0.666"
                        data-src="https://mmbiz.qpic.cn/mmbiz_jpg/erR1CfD1PHOLE76TvZWr4u4lurdA3BndDudeeyrGyVMeHULW3llHuVyl9hiazXXzzCD4HbBWZPqYnFfpCRtSA7g/640?wx_fmt=jpeg"
                        data-type="jpeg" data-w="1000"
                        style="width: 100% !important; height: auto !important; visibility: visible !important;"
                        data-index="12"
                        src="../../image/smhx_ysmh/section/guilin.jpg"
                        _width="100%" crossorigin="anonymous" alt="图片" data-fail="0"></p>
                  </section>
                </section>
                <section>
                  <section style="margin-top: 10px;color: rgb(102, 187, 104);font-size: 18px;letter-spacing: 2px;">
                    <p><span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;"></span>
                    </p>
                    <p><span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;">3.柳州遗体器官捐献者纪念园</span>
                    </p>
                  </section>
                  <section
                    style="margin-top: 8px;margin-right: 3px;margin-left: 3px;color: rgb(49, 49, 49);letter-spacing: 2px;font-size: 14px;line-height: 1.75em;transform: rotateZ(0deg);">
                    <p>地址:柳州市柳南区柳太路18号柳州市公墓管理处园区内</p>
                    <p>墓园联系电话：0772-2627262</p>
                    <p>捐献咨询电话：0772-2627262</p>
                    <p><br></p>
                    <p><img class="rich_pages wxw-img" data-backh="374" data-backw="540" data-ratio="0.693"
                        data-src="https://mmbiz.qpic.cn/mmbiz_jpg/erR1CfD1PHOLE76TvZWr4u4lurdA3BndPZq27hvg5PUXzmO7m1EP6QpxfdmUDXowbtzpQIuE6AvqIugxEYj9KQ/640?wx_fmt=jpeg"
                        data-type="jpeg" data-w="1000"
                        style="width: 100% !important; height: auto !important; visibility: visible !important;"
                        data-index="13"
                        src="../../image/smhx_ysmh/section/liuzhou.jpg"
                        _width="100%" crossorigin="anonymous" alt="图片" data-fail="0"></p>
                    <p><br></p>
                  </section>
                </section>
                <section>
                  <section style="margin-top: 10px;color: rgb(102, 187, 104);font-size: 18px;letter-spacing: 2px;">
                    <p>4<span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;">.钦州市遗体器官捐献者缅怀纪念园</span>
                    </p>
                  </section>
                  <section
                    style="margin-top: 8px;margin-right: 3px;margin-left: 3px;color: rgb(49, 49, 49);letter-spacing: 2px;font-size: 14px;line-height: 1.75em;transform: rotateZ(0deg);">
                    <p>地址:钦州市钦北区大垌镇歌标村福寿园人文纪念公园</p>
                    <p>墓园联系电话：0777-8887999</p>
                  <p><br></p>
                  <p><img class="rich_pages wxw-img" data-backh="327" data-backw="540" data-ratio="0.6061884669479606"
                      data-src="https://mmbiz.qpic.cn/mmbiz_jpg/erR1CfD1PHOLE76TvZWr4u4lurdA3Bnd9Zs7OZENBH2r47CSTHD53xYrwvtOibnXjic6QBznichSp9vJqdWbHUJNw/640?wx_fmt=jpeg"
                      data-type="jpeg" data-w="2133"
                      style="width: 100% !important; height: auto !important; visibility: visible !important;"
                      data-index="14"
                      src="../../image/smhx_ysmh/section/qinzhou.png"
                      _width="100%" crossorigin="anonymous" alt="图片" data-fail="0"></p>
                </section>
              </section>
                <section>
                  <section style="margin-top: 10px;color: rgb(102, 187, 104);font-size: 18px;letter-spacing: 2px;">
                    <p>5<span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;">.贵港遗体器官捐献者纪念园</span>
                    </p>
                  </section>
                  <section
                    style="margin-top: 8px;margin-right: 3px;margin-left: 3px;color: rgb(49, 49, 49);letter-spacing: 2px;font-size: 14px;line-height: 1.75em;transform: rotateZ(0deg);">
                    <p>地址:贵港市港北区根竹镇贵港市莲花山墓园内</p>
                    <p>墓园联系电话：0775-4631399</p>
                  <p>捐献咨询电话：0775-2770338</p>
                  <p><br></p>
                  <p><img class="rich_pages wxw-img" data-backh="327" data-backw="540" data-ratio="0.6061884669479606"
                      data-src="https://mmbiz.qpic.cn/mmbiz_jpg/erR1CfD1PHOLE76TvZWr4u4lurdA3Bnd9Zs7OZENBH2r47CSTHD53xYrwvtOibnXjic6QBznichSp9vJqdWbHUJNw/640?wx_fmt=jpeg"
                      data-type="jpeg" data-w="2133"
                      style="width: 100% !important; height: auto !important; visibility: visible !important;"
                      data-index="14"
                      src="../../image/smhx_ysmh/section/guigang.jpg"
                      _width="100%" crossorigin="anonymous" alt="图片" data-fail="0"></p>
                </section>
              </section>
              <section>
                  <section style="margin-top: 10px;color: rgb(102, 187, 104);font-size: 18px;letter-spacing: 2px;">
                    <p>6<span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;">.百色市遗体和人体器官捐献纪念园</span>
                    </p>
                  </section>
                  <section
                    style="margin-top: 8px;margin-right: 3px;margin-left: 3px;color: rgb(49, 49, 49);letter-spacing: 2px;font-size: 14px;line-height: 1.75em;transform: rotateZ(0deg);">
                    <p>地址:百色市百福生态陵园内（广西百色市右江区东坪路738县道7公里处）</p>
                    <p>墓园联系电话：0776—2800139</p>
                  <p><br></p>
                  <p><img class="rich_pages wxw-img" data-backh="327" data-backw="540" data-ratio="0.6061884669479606"
                      data-src="https://mmbiz.qpic.cn/mmbiz_jpg/erR1CfD1PHOLE76TvZWr4u4lurdA3Bnd9Zs7OZENBH2r47CSTHD53xYrwvtOibnXjic6QBznichSp9vJqdWbHUJNw/640?wx_fmt=jpeg"
                      data-type="jpeg" data-w="2133"
                      style="width: 100% !important; height: auto !important; visibility: visible !important;"
                      data-index="14"
                      src="../../image/smhx_ysmh/section/baise.png"
                      _width="100%" crossorigin="anonymous" alt="图片" data-fail="0"></p>
                </section>
              </section>
              <section>
                  <section style="margin-top: 10px;color: rgb(102, 187, 104);font-size: 18px;letter-spacing: 2px;">
                    <p>7<span
                        style="font-family: &quot;Microsoft YaHei&quot;, -apple-system-font, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, sans-serif;">.来宾市遗体器官捐献者纪念园</span>
                    </p>
                  </section>
                  <section
                    style="margin-top: 8px;margin-right: 3px;margin-left: 3px;color: rgb(49, 49, 49);letter-spacing: 2px;font-size: 14px;line-height: 1.75em;transform: rotateZ(0deg);">
                    <p>地址:来宾市凤凰岭梦园公墓</p>
                    <p>捐献咨询电话：0772-4280362</p>
                  <p><br></p>
                  <p><img class="rich_pages wxw-img" data-backh="327" data-backw="540" data-ratio="0.6061884669479606"
                      data-src="https://mmbiz.qpic.cn/mmbiz_jpg/erR1CfD1PHOLE76TvZWr4u4lurdA3Bnd9Zs7OZENBH2r47CSTHD53xYrwvtOibnXjic6QBznichSp9vJqdWbHUJNw/640?wx_fmt=jpeg"
                      data-type="jpeg" data-w="2133"
                      style="width: 100% !important; height: auto !important; visibility: visible !important;"
                      data-index="14"
                      src="../../image/smhx_ysmh/section/laibin.png"
                      _width="100%" crossorigin="anonymous" alt="图片" data-fail="0"></p>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
    <section style="margin: 10px auto;">
            <section style="text-align: center;display: flex;justify-content: center;">
              <section style="display: inline-block;text-align: right;">
                <section style="display: inline-block;">
                  <section style="width: 30px;">
                    <img
                      style="display: block; width: 30px !important; height: auto !important; visibility: visible !important;"
                      src="../../image/smhx_ysmh/section/1.png">
                  </section>
                </section>
                <section style="margin-top: -10px;width: 20px;">
                  <img
                    style="display: block; width: 20px !important; height: auto !important; visibility: visible !important;"
                    src="../../image/smhx_ysmh/section/2.png">
                </section>
                <section :style="{ backgroundImage: `url(` + bg3 + `)` }"
                  style="margin-top: -20px;background-attachment: initial;background-origin: initial;background-clip: initial;background-repeat: no-repeat;background-size: 100%;background-position: center bottom;">
                  <section data-brushtype="text"
                    style="padding: 10px 1.5em;font-size: 18px;font-weight: bold;text-align: center;letter-spacing: 1.5px;color: rgb(102, 166, 150);box-sizing: border-box;">
                    <span style="font-size: 20px;">云上缅怀
                    </span>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <section data-support="96编辑器" data-style-id="36303">
            <section style="margin-top: 10px;margin-bottom: 10px;text-align: center;">
              <section style="display: flex;justify-content:center;align-items:center;">
                <section
                  style="width:35px;height:35px;color:#fff;background-color:#2c9650;border-radius:50%;line-height:35px;transform: rotateZ(0deg);-webkit-transform: rotateZ(0deg);-moz-transform: rotateZ(0deg);-ms-transform: rotateZ(0deg);-o-transform: rotateZ(0deg);">
                  <p data-form="2" data-num="1">1</p>
                </section>
                <section
                  style="width: 94%;background-color: rgb(245, 255, 246);padding: 13px 13px 13px 18px;margin-left: -13px;box-sizing: border-box;"
                  data-width="94%">
                  <section
                    style="color:#323232;letter-spacing:2px;font-size:14px;line-height:1.75em;text-align:left;text-align: justify;transform: rotateZ(0deg);-webkit-transform: rotateZ(0deg);-moz-transform: rotateZ(0deg);-ms-transform: rotateZ(0deg);-o-transform: rotateZ(0deg);">
                    <p>登录广西人体器官捐献者缅怀纪念网站</p>
                    <p>http://qgjx.gx-stmcaca.com/#/home,进入“云上祭祀”版块开展缅怀纪念活动；<br></p>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <section data-support="96编辑器" data-style-id="36303">
            <section style="margin-top: 10px;margin-bottom: 10px;text-align: center;">
              <section style="display: flex;justify-content:center;align-items:center;">
                <section
                  style="width:35px;height:35px;color:#fff;background-color:#2c9650;border-radius:50%;line-height:35px;transform: rotateZ(0deg);-webkit-transform: rotateZ(0deg);-moz-transform: rotateZ(0deg);-ms-transform: rotateZ(0deg);-o-transform: rotateZ(0deg);">
                  <p data-form="2" data-num="2">2</p>
                </section>
                <section
                  style="width: 94%;background-color: rgb(245, 255, 246);padding: 13px 13px 13px 18px;margin-left: -13px;box-sizing: border-box;"
                  data-width="94%">
                  <section
                    style="color:#323232;letter-spacing:2px;font-size:14px;line-height:1.75em;text-align:left;text-align: justify;transform: rotateZ(0deg);-webkit-transform: rotateZ(0deg);-moz-transform: rotateZ(0deg);-ms-transform: rotateZ(0deg);-o-transform: rotateZ(0deg);">
                    <p>登录广西红十字会网站</p>
                    <p>http://www.gxredcross.org.cn/，扫描主页右侧二维码或点击主页右侧二维码下方“云上缅怀”标识进入广西人体器官捐献者缅怀纪念网开展缅怀纪念活动；</p>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <section data-support="96编辑器" data-style-id="36303">
            <section style="margin-top: 10px;margin-bottom: 10px;text-align: center;">
              <section style="display: flex;justify-content:center;align-items:center;">
                <section
                  style="width:35px;height:35px;color:#fff;background-color:#2c9650;border-radius:50%;line-height:35px;transform: rotateZ(0deg);-webkit-transform: rotateZ(0deg);-moz-transform: rotateZ(0deg);-ms-transform: rotateZ(0deg);-o-transform: rotateZ(0deg);">
                  <p data-form="2" data-num="3">3</p>
                </section>
                <section
                  style="width: 94%;background-color: rgb(245, 255, 246);padding: 13px 13px 13px 18px;margin-left: -13px;box-sizing: border-box;"
                  data-width="94%">
                  <section
                    style="color:#323232;letter-spacing:2px;font-size:14px;line-height:1.75em;text-align:left;text-align: justify;transform: rotateZ(0deg);-webkit-transform: rotateZ(0deg);-moz-transform: rotateZ(0deg);-ms-transform: rotateZ(0deg);-o-transform: rotateZ(0deg);">
                    <p>登录博爱八桂网站</p>
                    <p>http://boaibagui.gx-stmcaca.com/#/index，扫描主页右侧二维码或点击主页右侧二维码下方“云上缅怀”标识进入广西人体器官捐献者缅怀纪念网开展缅怀纪念活动；</p>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <section data-support="96编辑器" data-style-id="36303">
            <section style="margin-top: 10px;margin-bottom: 10px;text-align: center;">
              <section style="display: flex;justify-content:center;align-items:center;">
                <section
                  style="width:35px;height:35px;color:#fff;background-color:#2c9650;border-radius:50%;line-height:35px;transform: rotateZ(0deg);-webkit-transform: rotateZ(0deg);-moz-transform: rotateZ(0deg);-ms-transform: rotateZ(0deg);-o-transform: rotateZ(0deg);">
                  <p data-form="2" data-num="4">4</p>
                </section>
                <section
                  style="width: 94%;background-color: rgb(245, 255, 246);padding: 13px 13px 13px 18px;margin-left: -13px;box-sizing: border-box;"
                  data-width="94%">
                  <section
                    style="color:#323232;letter-spacing:2px;font-size:14px;line-height:1.75em;text-align:left;text-align: justify;transform: rotateZ(0deg);-webkit-transform: rotateZ(0deg);-moz-transform: rotateZ(0deg);-ms-transform: rotateZ(0deg);-o-transform: rotateZ(0deg);">
                    <p>关注“志愿世界”微信公众号，点击底部菜单栏“志愿世界”选择“云上缅怀”，进入线上缅怀界面，可点击献花、点蜡烛按钮对捐献者进行缅怀纪念。</p>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <p></p>
    <div class="weui-c-content">
      <van-row type="flex" justify="center">
        <img src="../../image/smhx_ysmh/section/10.png">
      </van-row>
      <p>
        <img src="../../image/smhx_ysmh/section/end.png" style="width: 100%;">
      </p>
      <!--        <h2 class="weui-c-title" style="text-align: center;">祭文</h2>
        <div class="weui-c-article">
          <p>遗体器官捐献为近代医学兴起以来所倡导，旨在推进医学之发展以及挽救器官功能衰竭而危及生命之人。受传统观念“身体发肤,受之父母,不敢毁伤”之影响，遗体器官捐献之推行曾步履惟难。近年来，幸得国家之倡导与推行，社会认知之提升，此事遂得逐步开展，造福社会之功日彰，此诚可传诸后世之大功德也。</p>
          <p>先贤有言曰：立德、立功、立言，是为“三不朽”，身虽殁而名永存。立德，树立高尚的行为准则以益世，如黄帝；立功，建立伟大的功勋以济世，如大禹；立言，创立普世的学说以劝世，如孔孟。夫自愿无偿捐献遗体与器官之义举，虽不能与大贤相提并论，然亦为立德者也，是中华民族“仁者爱人”的传统美德和“人道、博爱、奉献”的红十字精神之结合，构成新时代中华文化中人性光辉的闪光点。其举昭示世人：虽眇眇之躯亦可行天下大德之事。尘归尘，土归土，躯体终归大地，精神则长留人间，激励后来者恒向真、向善、向美。何其伟哉！</p>
          <p>此以缅怀与凭吊遗体器官捐献者！</p>
        </div> -->
    </div>
    <div class="weui-c-tools">
      <van-row>
        <img src="../../image/smhx_ysmh/section/12.gif" style="width: 100%;">
      </van-row>
    </div>
    <div class="weui-c-content">
      <section style="margin: 10px auto;">
        <section style="display: flex;justify-content: center;align-items: flex-end;">
          <section style="margin-right: -10px;width: 35px;">
            <section style="width: 35px;">
              <img src="../../image/smhx_ysmh/section/13.png"
                style="display: block; width: 35px !important; height: auto !important; visibility: visible !important;">
            </section>
          </section>
          <section
            style="margin-bottom: 10px;text-align: center;font-size: 16px;color: rgb(104, 152, 95);letter-spacing: 1.5px;">
            <span style="font-size: 18px;">
              <strong>献花、点蜡烛</strong>
            </span>
          </section>
          <section style="margin-left: -10px;width: 35px;">
            <section style="width: 35px;">
              <img src="../../image/smhx_ysmh/section/13.png"
                style="display: block; transform: scaleX(-1); width: 35px !important; height: auto !important; visibility: visible !important;">
            </section>
          </section>
        </section>
      </section>
      <interactive />
    </div>
    <div class="weui-c-tools" style="text-align: center;color: rgb(102, 166, 150);font-size: 18px;font-weight: 600;">
      <img src="../../image/smhx_ysmh/laz(2).jpg" style="width: 100%;height: 100%;">
      <p>END</p>
      <img src="../../image/smhx_ysmh/section/14.jpg" style="width: 100%;">
    </div>
    <p><br></p>
  </div>
</div></template>

<script>
import Vue from 'vue'
import { Col, Row } from 'vant'
import bg3 from '../../image/smhx_ysmh/section/3.png'
Vue.use(Col)
Vue.use(Row)
import '../../css/weui.css'
import '../../css/weuix.css'
import interactive from './interactive.vue'
export default {
  components: {
    interactive
  },
  data() {
    return {
      bg3: bg3
    }
  },
  mounted(){
    // document.querySelector('.van-nav-bar').style.display = 'none'
  }
}
</script>

<style scoped>.weui-c-article img {
  padding: 3px;
}

.weui-c-article p {
  text-indent: 0
}
</style>
